import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class NotificationService {
	constructor(private messageService: MessageService) {}

	notifySuccess(detail: string) {
		this.messageService.add({
			severity: 'success',
			summary: 'Réussi',
			detail: detail,
			life: 3000,
		});
	}
	notifyError(summary: string) {
		this.messageService.add({
			severity: 'error',
			summary: summary,
			detail: 'Erreur',
			life: 3000,
		});
	}
}
